/**
 * PostalShoppingScenrios
 * An enum used to describe the scenarios that will be handeled accordingly when
 * Postal Shopping is enabled and for personas (Lion /Leopard / NeoLion / NeoLeopard)
 */
export enum PostalShoppingScenarios {
    singleWithRevocationPeriod = 'single_revocation',
    singleExpiredRevocationPeriod = 'single_revocaton_expired',
    multiple = 'multiple',
    default = 'default',
    singleWithRevocationPeriodGigaCube = 'singleWithRevocationPeriodGigaCube',
    moreThanOneDeviceWithRevocationPeriodGigaCube = 'moreThanOneDeviceWithRevocationPeriodGigaCube',
    RevocationPeriodExpaired = 'RevocationPeriodExpaired' ,
    singleOrMoreWithAccessory = 'singleOrMoreWithAccessory' ,
}
